import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
  OverlayTrigger,
  Popover
} from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Card } from "components/Card/Card.jsx";
import { userActions } from '../../../redux/actions/user-actions';
import { roleActions } from '../../../redux/actions/role-actions';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { hasPermission } from 'helper/hasPermission';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { adminLabels } from '../../../redux/constant/admin-label-constant';
import OpenModalButton from '../../ThemeComponents/openModelButton';
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import { withRouter } from 'react-router-dom';
import AddEditUserForm from './../../ThemeComponents/AddEditUserForm';
import { listActions } from '../../../redux/actions/list-actions';
import SimpleReactValidator from "simple-react-validator";
import CustomerDropdown from "../Customers/CustomerDropdown";
import BrandsDropdown from "../Brands/BrandsDropdown";

// add new tag type form component and files //
import ListForm from '../Lists/ListForm';
import { objectsConstants as OC } from 'redux/constant/objects-constant';

var Modal = require('react-bootstrap-modal');

class BrandUsersList extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });

    const user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).result.user : undefined;
    let model_id;
    let model;
    if (user.model === 'App\\Customer' || user.model === 'App\\Brand') {
      model_id = user.model_id;
      model = this.props.match.params.model;
    }
    else {
      model_id = this.props.match.params.id;
      model = this.props.match.params.model;
    }

    this.state = {
      loggedInUserType: user.model,
      filtered: '',
      addModal: false,
      editModal: false,
      pageSize: 10,
      listData: [],
      model_type: model,
      initialState: {
        contact: {
          first_name: '',
          last_name: '',
          email: '',
          type_id: '',
          model_id: model_id,
          model: model,
        },
        user: {
          user_name: '',
          password: '',
          password_confirmation: '',
          role_id: '',
          model_id: model_id,
          model: model,
        }
      },
      user: {
        contact: {
          first_name: '',
          last_name: '',
          email: '',
          type_id: '',
          model_id: model_id,
          model: model,
        },
        user: {
          user_name: '',
          password: '',
          password_confirmation: '',
          role_id: '',
          model_id: model_id,
          model: model,

        },
        createUserChecked: true
      },
      submitted: false,
      showDropdown: this.props.match.params.id !== 'all' ? false : true,

      tagTypeList: {},
      addNewModelType: "",
      addNewModelDisplayTitle: "",
      tagTypeParentId: "",
      list_type_id: null,
      tagTypeAddModal: false
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleEditFormSubmit = this.handleEditFormSubmit.bind(this);
  };

  componentDidMount() {
    const { initialState } = this.state;
    // this.props.getAllUsersCall(initialState.contact.model_id, initialState.contact.model, this.state.filtered, 1, '', this.state.pageSize);
    this.props.getListCall('contact', "", "", "", "", "contact", false);
    this.props.getAllRolesCall(this.props.match.params.model);
    this.setState({
      ...this.state,
      editModal: false,
      user: this.state.initialState
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.model !== prevProps.match.params.model) {
      window.location.reload();
    }
  }

  handleFormSubmit(data) {
    if (this.validator.allValid()) {
      const { user, initialState } = this.state;
      this.props.storeUserCall({ ...user.contact, ...user.user, contact_info: false }).then(
        response => {
          this.props.getAllUsersCall(initialState.contact.model_id, initialState.contact.model, this.state.filtered, this.props.current_page, '', this.state.pageSize);
          this.setState({
            ...this.state,
            addModal: false,
            user: this.state.initialState
          })
        }
      );
    }
    else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  handleEditFormSubmit(data) {
    if (this.validator.allValid()) {
      this.setState({
        submitted: true
      });
      const { user, initialState } = this.state;
      this.props.updateUserCall({ ...user.contact, ...user.user, contact_info: false }, user.user.id, initialState.contact.model).then(
        response => {
          this.props.getAllUsersCall(initialState.contact.model_id, initialState.contact.model, this.state.filtered, this.props.current_page, '', this.state.pageSize);
          this.setState({
            ...this.state,
            editModal: false,
            user: this.state.initialState
          })
        }
      );
    }
    else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  contactTypeChangeHandler = (event) => {
    this.setState(prevState => ({
      ...prevState,
      user: {
        ...prevState.user,
        contact: {
          ...prevState.user.contact,
          type_id: event.value
        }
      }
    }));
  }

  filterSearchHandle = (e) => {
      this.setState({
          'filtered': e.target.value
      }, () => {
          this.refReactTable.fireFetchData()
      });
  }

  getState = state => {
    if (state.tagTypeAddModal !== undefined) {
      this.setState(prevState => ({
        ...prevState.tagTypeAddModal,
        ...state
      }));
    }
    else {
      this.setState(prevState => ({
        user: {
          ...prevState.user,
          ...state
        }
      }));

      this.validator = new SimpleReactValidator();
    }
  };

  getFullState = state => {
    this.setState(prevState => ({
      initialState: {
        user: {
          ...prevState.user.user,
          ...state
        },
        contact: {
          ...prevState.user.contact,
          ...state
        }
      }
    }), () => {
      if (this.state.initialState.contact.model_id !== 'all')
        this.props.getAllUsersCall(this.state.initialState.contact.model_id, this.props.match.params.model, this.state.filtered, 1, '', this.state.pageSize)
    });
  }

  handleDropDownAddNewSubmit = (listData, formType) => {
    let list;
    if (this.state.addNewModelType === 'region') {
      list = {
        title: listData.title,
        list_type_id: this.state.list_type_id,
        list_type: this.state.addNewModelType,
        parent_id: this.state.user.address.country_id,
        parent: this.state.user.address.country,
        component_name: this.state.addNewModelDisplayTitle
      };
    }
    else {
      list = {
        title: listData.title,
        list_type_id: this.state.list_type_id,
        list_type: this.state.addNewModelType,
        component_name: this.state.addNewModelDisplayTitle
      };
    }

    this.props.storeTagTypeCall(list).then(
      response => {
        this.props.getListCall(this.state.addNewModelType, "", "", "", "", this.state.addNewModelType, false);
        this.setState({
          ...this.state,
          tagTypeAddModal: false,
        });
      },
      error => {
        return error;
      }
    );
  }

  editUserCall(id) {
    this.props.getUserItemCall(id).then(response => {
      this.setState({
        editModal: true
      });
    });
  }

  deleteListItem(list_id) {
    const { initialState } = this.state;
    this.props.deleteListCall(list_id).then(response => {
      this.props.getAllUsersCall(initialState.contact.model_id, initialState.contact.model, this.state.filtered, this.props.current_page, '', this.state.pageSize);
    });
  }

  deleteConfirmListItem(list_id) {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Confirmalertfordelete typeName="User" onClosePro={onClose} deleteType={() => this.deleteListItem(list_id)} />
        )
      }
    })
  }

  listingPaginationData = (id, filter, page, sort, pageSize) => {
    const { initialState } = this.state;
    this.setState({ pageSize: pageSize }, function () {
      this.props.getAllUsersCall(initialState.contact.model_id, initialState.contact.model, this.state.filtered, page, sort, pageSize);
    });
  }

  checkPermissions = () => {
    if (HF.checkRoleAndDisplayMenu([
      "super admin",
      "zabin Staff"
    ])) {
      return hasPermission('customer-can-manage-users') || hasPermission('manage-brand-users');
    }
    else if (HF.checkRoleAndDisplayMenu([
      "customer manager"
    ])) {
      return hasPermission('customer-can-manage-users');
    }
    else if (HF.checkRoleAndDisplayMenu([
      "brand manager"
    ])) {
      return hasPermission('manage-brand-users');
    }
  }

  render() {
    const { filtered, initialState } = this.state;
    const { pages, loading } = this.props;
    const columns = [
      {
        Header: <div className='text-capitalize'>User List</div>,
        headerClassName: 'headerPagination',
        columns: [
          {
            Header: <div>User Name</div>,
            accessor: "user_name",
            className: "action-center"
          },
          {
            Header: <div className='text-capitalize'>First Name</div>,
            accessor: "contact.first_name",
            className: "action-center text-capitalize"
          },
          {
            Header: <div className='text-capitalize'>Last Name</div>,
            accessor: "contact.last_name",
            className: "action-center text-capitalize"
          },
          {
            Header: <div className='text-capitalize'>Contact Email</div>,
            accessor: "contact.email",
            className: "action-center"
          },
          {
            Header: <div className='text-capitalize'>Role</div>,
            accessor: "role.name",
            className: "action-center text-capitalize"
          },
          {
            Header: <div className='text-capitalize'>Last Login</div>,
            accessor: "last_login",
            className: "action-center text-capitalize"
          },
          {
            Header: "Actions",
            accessor: "id",
            Cell: ({ value }) => (
              <div>
                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission(['customer-can-manage-users','manage-brand-users']) ? `Edit User` : adminLabels.DONT_ALLOW}</Popover>}>
                  <span>
                    {
                      hasPermission(['customer-can-manage-users','manage-brand-users']) &&
                      <button type='button' className="editIcon orderDetailsAction " onClick={() => this.editUserCall(value)}>&nbsp;</button>
                    }
                    {
                      !hasPermission(['customer-can-manage-users','manage-brand-users']) &&
                      <button type='button' className="editIcon orderDetailsAction button_disabled" >&nbsp;</button>
                    }
                  </span>
                </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">{hasPermission(['delete-customer-user','manage-brand-users']) ? `Delete User` : adminLabels.DONT_ALLOW}</Popover>}>
                  <span>
                    {
                      hasPermission(['delete-customer-user','manage-brand-users']) &&
                      <button type='button' className="deleteIcon orderDetailsAction" onClick={() => this.deleteConfirmListItem(value)}>&nbsp;</button>
                    }
                    {
                      !hasPermission(['delete-customer-user','manage-brand-users']) &&
                      <button type='button' className="deleteIcon orderDetailsAction button_disabled" >&nbsp;</button>
                    }
                  </span>
                </OverlayTrigger>
              </div>
            ),
            className: "action-center",
            sortable: false
          }
        ]
      }
    ];

    return (
      <React.Fragment>
        <div className="content">
          <Grid fluid>
            <Row>
              <Col md={12}>
                <Card
                  ctTableResponsive
                  content={
                    <div>
                      {this.state.showDropdown &&
                        <div className="col-md-5" style={{ paddingRight: '10px', float: 'right' }}>
                          {this.props.match.params.model === 'customer' &&
                            <CustomerDropdown onReturnFullState={this.getFullState} stateProp={this.state} selectedCustomer={initialState.user.model_id} modelProp={this.state.loggedInUserType} />
                          }
                          {this.props.match.params.model === 'brand' &&
                            <BrandsDropdown onReturnFullState={this.getFullState} stateProp={this.state} selectedCustomer={initialState.user.model_id} modelProp={this.state.loggedInUserType} />
                          }
                        </div>
                      }


                      <Grid fluid>
                        <Row>
                          <Col md={12}>
                            <h3 style={{ textAlign: 'center', fontWeight: "500", textTransform: "capitalize" }}>User List</h3>
                          </Col>

                          <Col md={12}>
                            <div className="flexElem mt-xlg flexResponsive" style={{ "alignItems": "flex-start", "justifyContent": "space-between" }}>

                              <div className="block">
                                {(initialState.user.model_id !== 'all' && initialState.user.model_id !== undefined) &&
                                  <OpenModalButton
                                    openModal={hasPermission(['customer-can-manage-users','manage-brand-users']) ? HF.openModal.bind(this, "addModal") : null}
                                    classButton={['customBtn btnBlue', !hasPermission(['customer-can-manage-users','manage-brand-users']) ? 'button_disabled' : '']}
                                    buttonName={'Add User'}
                                    tooltipText={hasPermission(['customer-can-manage-users','manage-brand-users']) ? 'Add User' : adminLabels.DONT_ALLOW}
                                    classIcon={['']}
                                  />
                                }
                                {(initialState.user.model_id === 'all' || initialState.user.model_id === undefined) &&
                                  <OpenModalButton
                                    classButton={['customBtn btnBlue button_disabled']}
                                    buttonName={'Add User'}
                                    tooltipText={'Please select ' + initialState.contact.model + ' to Add new user'}
                                    classIcon={['']}
                                  />
                                }
                              </div>

                              <div className="custom-search-input">
                                <FormInputs
                                  ncols={["col-md-12"]}
                                  onChange={this.filterSearchHandle}
                                  proprieties={[
                                    {
                                      type: "text",
                                      bsClass: "form-control",
                                      placeholder: "Search Users",
                                      onChange: this.filterSearchHandle,
                                      name: "filter"
                                    }
                                  ]}
                                />
                              </div>
                            </div>
                          </Col>

                          <Col md={12} className="mt-xlg">
                            <ReactTable
                              noDataText='No data found'
                              data={this.props.usersData}
                              pages={pages}
                              loading={loading}
                              columns={columns}
                              defaultPageSize={10}
                              className="-striped listing responsive"
                              pageData={this.listingPaginationData}
                              ref={(refReactTable) => {this.refReactTable = refReactTable;}}
                              manual
                              onFetchData={(state, instance) => {
                                var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
                                var model_id = this.state.initialState.contact.model_id;
                                state.pageData(model_id, this.state.filter, state.page + 1, sort, state.pageSize);
                              }}
                            />
                          </Col>
                        </Row>
                      </Grid>

                      {/*Add Country Modal Start*/}
                      {this.props.UserData !== null &&
                        <Modal show={this.state.addModal} onHide={HF.closeModal.bind(this, "addModal")} aria-labelledby="ModalHeader" backdrop={false} >
                          <Modal.Header closeButton>
                            <Modal.Title id='ModalHeader' className="headerTitle text-capitalize">Add New User</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="row">
                              <div className="col-md-12">
                                <AddEditUserForm
                                  closeModel={HF.closeModal.bind(this, "addModal")}
                                  formTypePro="add"
                                  contactTypesProp={this.props.contactTypes}
                                  rolesProp={this.props.roles}
                                  contactObject={this.state.user}
                                  contactTypeChangeHandlerProp={this.contactTypeChangeHandler}
                                  contactProp={this.state.initialState}
                                  validatorProp={this.validator}
                                  returnState={this.getState}
                                  handleFormSubmitProp={this.handleFormSubmit}
                                  model_type={this.state.model}
                                />
                              </div>
                            </div>
                          </Modal.Body>
                        </Modal>
                      }
                      {/*Add Country Modal End*/}

                      {/*Edit Modal Start*/}
                      {this.props.UserData !== null &&
                        <Modal show={this.state.editModal} onHide={HF.closeModal.bind(this, "editModal")} aria-labelledby="ModalHeader" backdrop={false} >
                          <Modal.Header closeButton>
                            <Modal.Title id='ModalHeader' className="headerTitle text-capitalize">Edit User</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="row">
                              <div className="col-md-12">
                                <AddEditUserForm
                                  closeModel={HF.closeModal.bind(this, "editModal")}
                                  formTypePro="edit"
                                  contactObject={this.state.user}
                                  contactTypesProp={this.props.contactTypes}
                                  rolesProp={this.props.roles}
                                  contactTypeChangeHandlerProp={this.contactTypeChangeHandler}
                                  contactProp={this.props.editUser}
                                  validatorProp={this.validator}
                                  returnState={this.getState}
                                  handleFormSubmitProp={this.handleEditFormSubmit}
                                  model_type={this.state.model}
                                />
                              </div>
                            </div>
                          </Modal.Body>
                        </Modal>
                      }
                      {/*Edit Modal End*/}

                    </div>
                  } />
              </Col>
            </Row>
          </Grid>
        </div>
      </React.Fragment>
    );
  };
}

const mapDispatchToProps = dispatch => {
  return ({
    getListCall: (
      id, page, filter, sort, pageSize, component_name, pagination
    ) => {
      dispatch(
        listActions.getList(
          id, page, filter, sort, pageSize, component_name, pagination
        )
      );
    },
    storeUserCall: data => {
      return dispatch(userActions.storeCustomerUser(data));
    },
    getAllUsersCall: (
      id, model, filter, page, sort, pageSize, component_name, pagination
    ) => {
      let user_id = '';
      if (id === 'all') {
        user_id = '';
      }
      else if (id !== undefined) {
        user_id = id;
      }
      dispatch(
        userActions.getCustomerUsersPagination(
          user_id, model, filter, page, sort, pageSize, component_name, pagination
        )
      );
    },
    getUserItemCall: (id) => { return dispatch(userActions.getUser(id)) },
    updateUserCall: (data, id, model) => { return dispatch(userActions.editCustomerUser(data, id, model)) },
    deleteListCall: (id) => { return dispatch(userActions.deleteUser(id)) },
    getAllRolesCall: (model) => { return dispatch(roleActions.getUserRoles(model)) },
    storeTagTypeCall: (listData) => { return dispatch(listActions.storeList(listData)) }
  });
};

function mapStateToProps(state, ownProps) {
  const { contact } = state.listReducer;
  const { usersData, editUser } = state.userReducer;
  const { roles } = state.rolesReducer;

  return {
    contactTypes: contact,
    usersData,
    editUser,
    roles
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandUsersList));



// WEBPACK FOOTER //
// ./src/components/Admin/Users/UsersList.jsx